import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["onChange", "className", "label"];
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import React, { useCallback, useRef, useState } from "react";
import cx from "classnames";
import omit from "lodash/omit";
import PropTypes from "prop-types";
import { useTranslator } from "@jutro/locale";
import { generateComponentId } from "@jutro/platform";
import { IconButton } from "../IconButton/IconButton_DEPRECATED";
import { InputField } from "../inputs/InputField/InputField";
import { messages } from "./TreeView.messages";
import styles from "./TreeViewFilter.module.css";
export var TreeViewFilter = function (_ref) {
  var onChange = _ref.onChange,
    className = _ref.className,
    label = _ref.label,
    props = _objectWithoutProperties(_ref, _excluded),
    _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    query = _useState2[0],
    setQuery = _useState2[1],
    translator = useTranslator(),
    inputRef = useRef(null),
    filterClasses = cx(_filterInstanceProperty(styles), _defineProperty({}, styles.hideSearchIcon, Boolean(query)), className),
    onValueChange = useCallback(function (value) {
      setQuery(value), onChange && onChange(value);
    }, [setQuery, onChange]),
    clearFilter = useCallback(function () {
      var _inputRef$current, _inputRef$current$foc;
      onValueChange(""), null === (_inputRef$current = inputRef.current) || void 0 === _inputRef$current || null === (_inputRef$current$foc = _inputRef$current.focus) || void 0 === _inputRef$current$foc || _inputRef$current$foc.call(_inputRef$current);
    }, [onValueChange, inputRef]),
    clearButton = React.createElement(IconButton, {
      className: styles.clearButton,
      icon: "gw-cancel",
      onClick: clearFilter,
      ariaLabel: translator(messages.clearFilter),
      noDeprecationWarnings: ["IconButton"]
    });
  return React.createElement("div", {
    className: styles.wrapper
  }, React.createElement(InputField, _extends({
    ref: inputRef,
    id: generateComponentId("TreeViewFilter"),
    label: label || messages.filterLabel,
    hideLabel: !0,
    placeholder: messages.filterPlaceholder,
    icon: "gw-search",
    iconPosition: "right",
    className: filterClasses
  }, props, {
    value: query,
    onValueChange: onValueChange
  })), query && clearButton);
};
export var treeViewFilterProps = omit(InputField.propTypes, ["id"]);
TreeViewFilter.propTypes = _objectSpread(_objectSpread({}, treeViewFilterProps), {}, {
  onChange: PropTypes.func
}), TreeViewFilter.__docgenInfo = {
  description: "",
  methods: [],
  displayName: "TreeViewFilter",
  props: {
    onChange: {
      type: {
        name: "func"
      },
      required: !1,
      description: ""
    }
  },
  composes: ["lodash"]
}, TreeViewFilter.__docgenInfo = {
  componentName: "TreeViewFilter",
  packageName: "@jutro/components",
  description: "",
  displayName: "TreeViewFilter",
  methods: [],
  actualName: "TreeViewFilter",
  props: {
    onChange: {
      type: {
        name: "func"
      },
      required: !1,
      description: ""
    }
  },
  composes: ["lodash"]
};